module.exports = __webpack_public_path__ + "static/media/slide-img-2.a738f853.png";